<script setup>
import { computed } from 'vue';
import DarkModeStore from '@o/store'
const { options, isPro } = DarkModeStore()
import { Preview, Range, Badge } from '@components'

const filters = computed(() => {
    return `filter: brightness(${options.color_filter_brightness || 100}%) contrast(${options.color_filter_contrast || 90}%) grayscale(${options.color_filter_grayscale || 0}%) sepia(${options.color_filter_sepia || 10}%) !important`
})

const color = computed(() => {
    return {
        text: '#d1cbc1',
        link: '#60abe6',
        link_hover: '#60abe6',
        bg: '#2a2a2a',
        input_bg: '#252525',
        input_border: '#fff',
        input_text: 'rgb((78, 81, 81)',
        button_bg: 'rgb(7 92 180)',
        button_text: '#button_text',
    }
})

</script>
<template>
    <div class="flex justify-between w-full gap-6 flex-col sm:flex-row">
        <Card borderless transparent class="w-full gap-6" locked>

            <!-- brightness -->
            <Card borderless transparent locked>
                <Heading> 
                    <Row inline class="items-center"><Row locked :ProBadge="false">Brightness</Row> <ProBadge text="" /></Row>
                    <Hints locked>Adjust your preferred dark mode brightness</Hints></Heading>
                <Range v-model="options.color_filter_brightness" :default="$default.color.filter_brightness.default" locked/>
            </Card>

            <!-- contrast  -->
            <Card borderless transparent locked>
                <Heading> 
                <Row inline class="items-center"><Row locked :ProBadge="false">Contrast</Row> <ProBadge text="" /></Row>
                <Hints>Adjust your desired dark mode contrast</Hints></Heading>
                <Range v-model="options.color_filter_contrast" :default="$default.color.filter_contrast.default" locked/>
            </Card>

            <!-- grayscale  -->
            <Card borderless transparent locked>
                <Heading>
                    <Row inline class="items-center"><Row locked :ProBadge="false">Grayscale</Row> <ProBadge text="" /></Row>
                    <Hints>Adjust your preferred dark mode Sepia</Hints></Heading>
                <Range v-model="options.color_filter_grayscale" :default="$default.color.filter_grayscale.default" locked/>
            </Card>

            <!-- sepia  -->
            <Card borderless transparent :class="{'pointer-events-none' : !isPro}">
                <Heading>
                    <Row inline class="items-center"><Row locked :ProBadge="false">Sepia</Row> <ProBadge text="" /></Row>
                     <Hints>Adjust your preferred dark mode Grayscale</Hints></Heading>
                <Range v-model="options.color_filter_sepia" :default="$default.color.filter_sepia.default" locked/>
            </Card>
            
        </Card>
        <div :style="filters">
            <Preview size="lg" :color="color"></Preview>
        </div>
    </div>
</template>